import { useState } from "react";
import { Outlet } from "react-router-dom";
import BottomNav from "@/components/BottomNav";
import CreateSheet from "@/components/CreateSheet";

const TabLayout = () => {
    const [sheetOpen, setSheetOpen] = useState(false);

    return (
        <div className="screen" data-testid="tab-layout">
            <main className="flex-1 overflow-y-auto no-scrollbar pb-24" data-testid="tab-content">
                <Outlet />
            </main>
            <BottomNav onCreatePress={() => setSheetOpen(true)} />
            <CreateSheet open={sheetOpen} onClose={() => setSheetOpen(false)} />
        </div>
    );
};

export default TabLayout;
